import * as Yup from 'yup';
import exportControlTiemposFormModel from './exportControlTiemposFormModel';
const {
  formField: {
    // DATOS AREA
    from,
    to,
  },
} = exportControlTiemposFormModel;

export default [
  Yup.object().shape({
    [from.name]: Yup.string().required(`${from.requiredErrorMsg}`),
    [to.name]: Yup.string().required(`${to.requiredErrorMsg}`),
  }),
];
